import { Checkbox } from 'antd';
import get from 'lodash/get';

import ErrorMessage from '~/shared/components/form-fields/error-message/error-message';

import '~/shared/components/form-fields/checkbox-field/checkbox-field.scss';

type CheckboxFieldPropsType = {
  isHiddenError: boolean;
  type: string;
  input: Record<string, unknown>;
  meta: {
    touched: boolean;
    error: string;
  };
};

const CheckBoxField = ({ input, meta, type, isHiddenError }: CheckboxFieldPropsType) => {
  return (
    <div className="checkbox-field">
      <Checkbox {...input} type={type} />
      {!isHiddenError && get(meta, 'meta.touched') && get(meta, 'error') && <ErrorMessage error={get(meta, 'error')} />}
    </div>
  );
};

export default CheckBoxField;
